export default __webpack_public_path__ + "static/media/(5).7468ed05.jpg";